import { Clock, TrendingUp, Star } from "lucide-react";

const CARDS = [
  {
    icon: Clock,
    title: <>Recuperas <span className="underline decoration-[#F26522] decoration-[2px] underline-offset-[5px]">tu vida</span></>,
    text: "La empresa avanza sin depender de ti en cada decisión. Más tiempo, más foco en lo que importa, y una vida mejor fuera del negocio.",
  },
  {
    icon: TrendingUp,
    title: <>Tu empresa crece sin que tú seas <span className="underline decoration-[#F26522] decoration-[2px] underline-offset-[5px]">el límite</span></>,
    text: "Dejas de ser el cuello de botella. La organización escala porque ya no todo pasa por ti.",
  },
  {
    icon: Star,
    title: <>Tu empresa <span className="underline decoration-[#F26522] decoration-[2px] underline-offset-[5px]">vale más</span></>,
    text: "Más predecible, más ordenada, menos dependiente de ti. Una empresa que puede crecer —o venderse— por sí sola.",
  },
];

export default function WhatThisMeans() {
  return (
    <section data-testid="what-this-means-section" className="pt-12 pb-20 lg:pt-14 lg:pb-28 bg-slate-50">
      <div className="container-eos">

        <div className="reveal">
          <span className="eyebrow">Lo que esto significa para ti</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy-800 leading-tight">
            No solo cambia tu empresa.<br />
            <span className="text-[#F26522]">Es lo que cambia en tu vida.</span>
          </h2>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {CARDS.map((c, i) => (
            <article
              key={i}
              data-testid={`what-means-card-${i + 1}`}
              className="reveal bg-navy-800 border-t-[3px] border-[#F26522] rounded-2xl p-8 flex flex-col"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Icon + Title en la misma línea */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-[#F26522] flex items-center justify-center shrink-0 shadow-lg shadow-[#F26522]/40">
                  <c.icon className="w-5 h-5 text-white" strokeWidth={2} />
                </div>
                <h3 className="font-display font-bold text-white text-xl leading-snug">
                  {c.title}
                </h3>
              </div>

              {/* Body */}
              <p className="mt-4 text-slate-400 text-base leading-relaxed">
                {c.text}
              </p>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
}
